/**
 * @generated SignedSource<<131edcb0f95a370a573ba0a98051fd30>>
 * @relayHash 729512e71d7046a33446885068dd2b76
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID be73bb3e01cce8d76692f962cd1fe84f928762d0c01953225814bcdb213f1eb3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FirstCreateViewQuery } from './FirstCreateViewQuery.graphql';

const node: PreloadableConcreteRequest<FirstCreateViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "be73bb3e01cce8d76692f962cd1fe84f928762d0c01953225814bcdb213f1eb3",
    "metadata": {},
    "name": "FirstCreateViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
